import React from 'react'
import styled from '@emotion/styled'
import { PageCrumbs } from 'components'
import { Button, Icon } from 'antd'
import { EXPORT_PERMISSION } from 'utils/constants'
import { Export, SCAN_TYPE_COMPARE } from 'components/Export'
import { useUser } from 'context/user-context'
import { navigate } from '@reach/router'

const StyledScansCompareTop = styled.div(props => ({
  display: 'grid',
  gridTemplateColumns: props.isDetailsView ? '1fr 100px' : '1fr 90px 192px',
  gridGap: 10,
  marginBottom: 20
}))

const ScansCompareTop = ({
  scanSettingsName,
  exportFilters,
  onExportError,
  scanA,
  scanB,
  isDetailsView,
  setDetailsView,
  scanSettingsId
}) => {
  const user = useUser()
  const canExport = user.permissions.filter(p => EXPORT_PERMISSION.includes(p))

  let crumbs = [
    { name: 'Scan Settings', icon: 'bars', path: '/scan-settings', separator: '>' },
    { name: scanSettingsName, separator: '>', path: `/scan-settings/${scanSettingsId}/scans/` },
    {
      name: scanA,
      separator: '|'
    },
    {
      name: scanB
    }
  ]

  const onBackToCompare = () => {
    setDetailsView({ details: null, document_a_id: null, document_b_id: null })
  }

  return (
    <StyledScansCompareTop isDetailsView={isDetailsView}>
      <PageCrumbs separator="" crumbs={crumbs} />
      {!isDetailsView && (
        <Button type="primary" onClick={() => navigate('../../scans')}>
          <Icon type="left" />
          BACK
        </Button>
      )}
      {isDetailsView && (
        <Button type="primary" onClick={() => onBackToCompare()}>
          <Icon type="left" />
          BACK
        </Button>
      )}
      {!isDetailsView && canExport && (
        <Export
          scanId={[scanA, scanB]}
          exportFilters={exportFilters}
          scanContext={SCAN_TYPE_COMPARE}
          onExportError={onExportError}
        />
      )}
    </StyledScansCompareTop>
  )
}

export default ScansCompareTop
